import * as React from 'react';
import dayjs from 'dayjs';
import { get } from 'lodash';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { actionsGenerator, asyncActions } from '@docavenue/core';
import { Button, DialogActions, DialogContent } from '@mui/material';
import { IconPlayRoundFilled } from '@maiia/design-system';
import { Trans, useTranslation } from '@/src/i18n';

import { getCardFullName, getSubstitute } from '../../utils';
import Dialog from '@/components/molecules/Dialog/Dialog';

const publicVideoSessionsActions = actionsGenerator({
  resource: 'video-sessions',
  scope: 'pat-public',
});

const DialogNowTlc = ({ card, open, setOpen }: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter();
  const [waitingTlcPatientCount, setWaitingTlcPatientCount] = React.useState(0);
  const { isSubstitute, substitute } = getSubstitute(card);
  const substituteFullName = `${substitute?.firstName} ${substitute?.lastName}`;

  const onClick = React.useCallback(() => {
    router.push({
      pathname: '/tlc/[center-id]/[practitioner-id]',
      query: {
        'center-id': card.center.id,
        'practitioner-id': card.professional.practitionerId,
        url: card.url,
      },
    });
  }, [card]);

  React.useEffect(() => {
    (async () => {
      const publicVideoSessions = await asyncActions(
        dispatch,
        publicVideoSessionsActions.getList({
          practitionerId: card.professional.practitionerId,
          centerId: card.center.id,
        }),
      );

      setWaitingTlcPatientCount(publicVideoSessions?.total || 0);
    })();
  }, []);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} title={t('no-rdv-tlc')}>
      <DialogContent>
        <div className="popup-tlc-info">
          <p>
            <Trans
              i18nKey="you-are-about-to-contact-this-practitioner"
              components={{ strong: <strong /> }}
              values={{
                name: isSubstitute
                  ? substituteFullName
                  : getCardFullName(t, card),
              }}
            />
          </p>
          <div className="info-attente">
            <p>
              <Trans
                i18nKey="the-tlc-closes-at"
                components={{ strong: <strong /> }}
                values={{
                  closingTime: dayjs(
                    get(card, 'settings.teleconsultationAvailabilityEndTime'),
                  ).format('HH:mm'),
                }}
              />
            </p>
            <p>
              {waitingTlcPatientCount > 0 ? (
                <Trans
                  i18nKey="waiting-patient-count"
                  components={{ strong: <strong /> }}
                  values={{
                    count: waitingTlcPatientCount,
                  }}
                />
              ) : (
                t('no_waiting_tlc_immediate')
              )}
            </p>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          color="secondary"
          variant="contained"
          endIcon={<IconPlayRoundFilled />}
          onClick={onClick}
          data-cy="btn-prat-begin-tlc"
        >
          {t('begin-tlc')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogNowTlc;
